import React,{Component} from 'react';
import _ from 'lodash';
import {Checkbox, Button} from 'antd';
import { routeActions } from 'react-router-redux';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import signInAsync from 'helpers/signInAsync';
import fetchMeAsync from 'helpers/fetchMeAsync';
import { actions as meAction } from 'modules/me';
import base64 from 'base-64';
import { logAsync } from 'helpers/elogAsync';
import './style.css';

const container = connect (
  createSelector(
    (state) => ({
    }),
  )
)

class Login extends Component {

  state = {
    isErrorShow: false
  }

  handleLogin = () => {
    const {dispatch} = this.props;
    const email = this.refs.email.value;
    const password = this.refs.password.value;
    signInAsync({
      email: email,
      password: password,
    })
    .then(() => {
      const {register_email} = localStorage;
      logAsync({
        type: "sPOP-login",
        data: {
          email: email,
          password: password,
          user: register_email
        }
      })
      localStorage.email = email;
      localStorage.password = base64.encode(password);
      fetchMeAsync()
      .then(() => {
        dispatch(meAction.meInit())
        .then(() => {
          dispatch(routeActions.push({
            pathname: '/me'
          }))
        })
      })
    })
    .catch(() => {
      this.setState({
        isErrorShow: true
      })
    })
  }

  handleRegister = () => {
    const {dispatch} = this.props;
    dispatch(routeActions.push({
      pathname: '/register'
    }))
  }
  render() {
    return (
      <div className="padding-md background-color margin-left-md">
        <div className="register-title padding-bottom-sm">
          <i className="mediaType-icon login-icon"></i>
          <div className="margin-left-md">登錄</div>
        </div>
        <div className="login-form">
          <input
            placeholder='帳號'
            type='text'
            ref="email"
            className="form-control margin-bottom-lg"/>
          <input
            placeholder='密碼'
            type='password'
            ref="password"
            className="form-control margin-bottom-lg"/>
          <div className="margin-bottom-lg">
            <div className="pull-right">
              <a href="/forget.html">忘記密碼？</a>
            </div>
          </div>
          {this.state.isErrorShow &&
            <div className="error">
              用戶名 / 密碼錯誤
            </div>
          }
          <div className="login-button margin-bottom-lg">
            <Button type="primary" onClick={this.handleLogin}>登錄</Button>
          </div>
          <div className="register-button">
            <Button type="primary" onClick={this.handleRegister}>開通賬號</Button>
          </div>
        </div>

      </div>
    )
  }
}
export default container(Login)



/** WEBPACK FOOTER **
 ** ./src/app/modules/sidebar/components/Login.js
 **/